const apiConfig = {
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5051/api'
};

export default apiConfig;
